import React, {PureComponent} from 'react'

interface Props<T> {
  data: Array<T>
  renderItem(item: T): JSX.Element
  keyExtractor(item: T): string
}

class Grid<T> extends PureComponent<Props<T>, object> {
  render() {
    const {data, renderItem, keyExtractor} = this.props

    return (
      <div style={wrapper}>
        {data.map(item => (
          <div key={keyExtractor(item)}>{renderItem(item)}</div>
        ))}
      </div>
    )
  }
}

export default Grid

const wrapper = {
  display: 'grid',
  gridTemplateColumns: '200px 200px 200px',
  gridGap: '10px',
  backgroundColor: '#fff',
  color: '#444',
  margin: '40px'
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Grid.tsx